__turbopack_context__.v({
  "fadeInUp": "imageTextComponent-module__9bp7Ha__fadeInUp",
  "imageAnimation": "imageTextComponent-module__9bp7Ha__imageAnimation",
  "sectionAnimation": "imageTextComponent-module__9bp7Ha__sectionAnimation",
  "textAnimation": "imageTextComponent-module__9bp7Ha__textAnimation",
});
